<h1>{{ 'static-content-download-app.text.title' | translate }}</h1>

<div>{{ 'static-content-download-app.text.description' | translate }}</div>

<lib-spacer></lib-spacer>

<!--TODO: add link to download app on both platforms-->
<div
  fxLayout="{{
    (breakpointService.isPhoneViewObservable | async) ? 'column' : 'row'
  }}"
  fxLayoutAlign="start start"
>
  <div class="image-button-wrapper" (click)="triggerDownloadPwa()">
    <div
      class="image-wrapper"
      matRipple
      [matRippleCentered]="true"
      [matRippleUnbounded]="false"
    >
      <img [src]="downloadOnAppleStoreBadge" alt="download-on-apple-store" />
    </div>
  </div>

  <lib-spacer></lib-spacer>

  <div class="image-button-wrapper" (click)="triggerDownloadPwa()">
    <div
      class="image-wrapper"
      matRipple
      [matRippleCentered]="true"
      [matRippleUnbounded]="false"
    >
      <img [src]="downloadOnGooglePlayBadge" alt="download-on-google-play" />
    </div>
  </div>
</div>
